export default {
  input: {
    display: 'flex',
    flex: 1,
    minWidth: 180,
  },

  inputRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  valuesSection: {
    backgroundColor: 'var(--c-gray-2)',
    borderRadius: 8,
    padding: 8,
    width: '98%',
  },
  chipsSection: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    marginTop: 10,
    maxHeight: 140,
    overflowY: 'auto',
    padding: 6,
    borderRadius: 8,
    backgroundColor: '#f7f7f7',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '5px 10px',
    borderRadius: 999,
    backgroundColor: '#fff',
    border: '1px solid rgba(0,0,0,0.08)',
    fontSize: 13,
    color: '#444',
    boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
  },
  chipText: {
    maxWidth: 180,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chipCloseContainer: {
    display: 'inline-flex',
    marginLeft: 6,
  },
  chipClose: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 18,
    height: 18,
    borderRadius: '50%',
    border: '1px solid rgba(0,0,0,0.08)',
    backgroundColor: '#f2f2f2',
    color: '#666',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1,
    cursor: 'pointer',
    transition: 'all 0.15s ease',
  },
  chipCloseHover: {
    backgroundColor: '#ff4d4f',
    color: '#fff',
    borderColor: '#ff4d4f',
    transform: 'scale(1.05)',
  },
  moreChip: {
    padding: '5px 10px',
    borderRadius: 999,
    border: '1px dashed #aaa',
    background: 'transparent',
    fontSize: 12,
    color: '#666',
    cursor: 'pointer',
  },
};
